export type SuccessEnvelope<T> = {
  data: T;
  meta?: { requestId?: string };
};

export type ErrorEnvelope = {
  error: {
    code: string;
    message: string;
    details?: unknown;
  };
  meta?: { requestId?: string };
};

export function unwrap<T>(envelope: { data: T } | T): T {
  if (envelope && typeof envelope === "object" && "data" in (envelope as object)) {
    return (envelope as { data: T }).data;
  }
  return envelope as T;
}
